import api from "../api/axios";

/**
 * Fetch the miscellaneous report.
 * @param {Object} filters - { start_date, end_date }
 */
export const getMiscReport = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );
  const response = await api.get("/reports/misc", { params });
  return response.data;
};
